/*eslint-disable max-lines */
import React, { useContext, useState } from 'react';
import { CircularProgress, InputBase, makeStyles } from '@material-ui/core';
import SearchIconInPatientsHeader from '../../../assets/images/logo/serch-icon-in-patients-header.svg';
import { useDispatch, useSelector } from 'react-redux';

import {
    getPatients,
    clearPatients,
    setSelectedPatient
} from '../../../redux/Patient/PatientAction';
import Age from '../../UI/patient/Age';
import Gender from '../../UI/patient/Gender';
import { useLocation, withRouter } from 'react-router-dom';
import { alphabets, farsiLetter, number } from '../../../utils/validationRegex';
import MessagesContext from '../../../contexts/messagesContext';
import useAddPatient from '../../AllPatients/AddPatient';
import AlertDialog from '../../UI/Dialogs/AlertDialog';
import { PropTypes } from 'prop-types';
import { createLoadingSelector } from '../../../redux/Loading/LoadingSelector';
import * as type from '../../../redux/Patient/PatientType';
import { getClinicId } from '../../../utils/storage';

const styles = makeStyles((theme) => ({
    search: {
        position: 'relative',
        borderRadius: '10px',
        padding: '5px 13px',
        backgroundColor: 'rgba(65, 162, 250, 0.16)',
        [theme.breakpoints.down(1025)]: {
            backgroundColor: '#f5f6fa'
        },
        flexGrow: '1',
        '&:hover': {
            backgroundColor: (theme.palette.common.white, 0.25)
        },
        marginRight: '16px',
        marginLeft: '16px',
        display: 'flex',
        alignItems: 'center'
    },
    searchIcon: {
        height: '100%',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '0 4px'
    },
    inputRoot: {
        color: 'inherit',
        fontFamily: 'inherit',
        width: '100%',
        zIndex: '1200'
    },
    inputInput: (props) => ({
        padding: theme.spacing(1, 1, 1, 0),
        // vertical padding + font size from searchIcon
        paddingRight: props.rtl && `calc(1em + ${theme.spacing(4)}px)`,
        paddingLeft: !props.rtl && '10px',
        transition: theme.transitions.create('width'),
        color: '#545e66',
        width: '100%',
        [theme.breakpoints.down(400)]: {
            paddingRight: props.rtl && `calc(1em + 15px)`,
            fontSize: !props.rtl && '12px'
        },
        [theme.breakpoints.down(350)]: {
            paddingRight: `calc(1em + 7px)`,
            fontSize: props.rtl ? '12px' : '10px'
        }
    }),
    resultContainer: {
        position: 'absolute',
        top: '100%',
        left: '0',
        right: '0',
        backgroundColor: 'white',
        maxHeight: '40vh',
        overflow: 'auto',
        zIndex: '2000',
        color: '#3d454a',
        borderRadius: '5px',
        boxShadow: '0 2px 14px 0 rgba(0, 0, 0, 0.22)',
        fontSize: '13px'
    },
    resultItem: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: '13px',
        borderBottom: '1px solid #e8e8e8',
        cursor: 'pointer',
        '& img': {
            padding: '0 5px'
        }
    },
    overallInfo: {
        display: 'flex',
        flexFlow: 'row-reverse',
        justifyContent: 'center'
    },
    overlay: {
        position: 'fixed',
        top: '0',
        left: '0',
        bottom: '0',
        right: '0',
        zIndex: '1150'
    },
    notFound: {
        textAlign: 'center',
        fontWeight: 'bold',
        padding: '10px'
    },
    loading: {
        display: 'flex'
    },
    progressRoot: {
        height: '23px !important',
        width: '23px !important',
        color: '#063f5e'
    }
}));
// why i added a isTest prop : cause when i call REQUEST_GET_PATIENTS
// loading:true since we'll no longer access to the patients list and ...
// in my opinion is not a best way, but if i find a better way, i'll change it
const Search = ({ isTest = false }) => {
    const [searchTerm, setSearchTerm] = useState('');
    const { messages } = useContext(MessagesContext);
    const patients = useSelector((state) => state.patient.patients);
    const loadingSelector = createLoadingSelector(type.GET_PATIENTS.REQUEST);
    const isLoading = useSelector(loadingSelector);
    const dispatch = useDispatch();
    const classes = styles();
    const { dialog, setDialog, goToPatientPage } = useAddPatient();
    const { pathname } = useLocation();
    const isNew = !!pathname?.split('/').filter((item) => item)[2];
    const clinicId = getClinicId();

    function handleChange(event) {
        const value = event.target.value;
        let timer;
        if (number.test(value) || alphabets.test(value) || farsiLetter.test(value)) {
            setSearchTerm(value);
        } else if (value === '') {
            setSearchTerm(value);
            dispatch(clearPatients());
            // setLoading(false);
        }
        if (value.length > 3) {
            if (!isTest) {
                dispatch({ type: type.GET_PATIENTS.REQUEST });
            }

            clearTimeout(timer);
            timer = setTimeout(() => {
                getPatientList(value);
            }, 350);
        }
    }
    async function getPatientList(value) {
        if (!value || value.trim() === '') {
            dispatch(clearPatients());
            return;
        }
        if (number.test(value)) {
            const EnParams = {
                offset: 0,
                limit: 20,
                name: null,
                nationalId: value.trim(),
                clinic: clinicId
            };
            await dispatch(getPatients(EnParams));
        } else if (farsiLetter.test(value) || alphabets.test()) {
            const FaParams = {
                offset: 0,
                limit: 20,
                name: value.trim(),
                nationalId: null,
                clinic: clinicId
            };
            await dispatch(getPatients(FaParams));
        }
    }
    function handleOverlayClick() {
        setSearchTerm('');
        dispatch(clearPatients());
    }

    function handleGetPatient(patient) {
        dispatch(setSelectedPatient(patient));
        goToPatientPage(patient);
        // goToPatientPage(patient);
        // props.setSelectedPatient(patient);
        setSearchTerm('');
        dispatch(clearPatients());
        // props.clearPatients();
    }
    return (
        <>
            <AlertDialog
                open={dialog}
                alertText={messages.alerts.warningNumberOfPatients}
                cancelText={messages.alerts.ok}
                handleClose={() => setDialog(false)}
                primaryCancelButton
            />
            <div className={classes.search}>
                <div className={classes.searchIcon}>
                    <img src={SearchIconInPatientsHeader} />
                </div>
                <InputBase
                    placeholder={messages.mainSearch}
                    classes={{
                        root: classes.inputRoot,
                        input: classes.inputInput
                    }}
                    value={searchTerm}
                    inputProps={{ 'aria-label': 'search', 'data-testid': 'search' }}
                    onChange={(event) => handleChange(event)}
                />
                {isLoading && !isNew && (
                    <div className={classes.loading}>
                        <CircularProgress className={classes.progressRoot} />
                    </div>
                )}
                {patients && patients.length && searchTerm?.length > 3 && !isLoading ? (
                    <>
                        <div className={classes.overlay} onClick={() => handleOverlayClick()}></div>
                        <div className={classes.resultContainer}>
                            {patients.map((patient, index) => (
                                <div
                                    key={index}
                                    className={classes.resultItem}
                                    onClick={() => handleGetPatient(patient)}
                                    data-testid="resultSearch"
                                >
                                    <div>
                                        {patient.first_name} {patient.last_name}
                                    </div>
                                    <div className={classes.overallInfo}>
                                        {patient.gender && (
                                            <Gender height="20" gender={patient.gender} />
                                        )}
                                        {patient.dob && <Age dob={patient.dob} />}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </>
                ) : !patients.length && searchTerm?.length > 3 && !isLoading ? (
                    <>
                        <div className={classes.resultContainer}>
                            <div className={classes.notFound}>{messages.noResult}</div>
                        </div>
                        <div className={classes.overlay} onClick={() => handleOverlayClick()}></div>
                    </>
                ) : null}
            </div>
        </>
    );
};
Search.propTypes = {
    isTest: PropTypes.bool
};
export default withRouter(Search);
